module.exports = __webpack_public_path__ + "static/media/9-7.d7bcaffd.mp3";